import _ from "lodash";
import { Modal } from "react-bootstrap";
import { Button } from "../../components";
import { DateInput, FormLabel, FormSelect } from "../../components/forms";
import { GenericUserSelect } from "../../components/forms/selects";
import StandardParagraphTypeSelect from "../../components/forms/selects/StandardParagraphTypeSelect";
import { useStandardParagraphFilterContext } from "./hooks/StandardParagraphFilterContext";
import ThemedModal from "../../components/utilities/ThemedModal";

export const StandardParagraphFiltersModal = (props) => {
    const {
        showFilterModal,
        setShowFilterModal,
        clearFilter,
        applyFilter
    } = useStandardParagraphFilterContext();

    const handleClose = () => setShowFilterModal(false);

    const onCancel = () => {
        clearFilter();
        handleClose();
    }

    const onApply = () => {
        applyFilter();
        handleClose();
    }

    return <Modal {...props} size="lg" show={showFilterModal} onHide={handleClose} centered>
        <ThemedModal.Header closeButton>
            <Modal.Title>Standard Paragraph Filters</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body>
            <StandardParagraphFilters />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={clearFilter}>Clear Filters</Button>
            <Button variant="success" onClick={onApply}>Apply Filters</Button>
            <Button variant="light" onClick={onCancel}>Cancel</Button>
        </Modal.Footer>
    </Modal>

}

const UserOperationFilter = ({ minDate, maxDate, byIds, update, operation }) => (
    <>
        <div className="col-12 col-lg-8 d-flex flex-row">
            <span className="col mt-auto">
                <DateInput
                    label={`${operation}`}
                    value={minDate}
                    maxDate={new Date()}
                    onBlur={(date) => update(`min${operation}Date`, date)}
                    disableAnimations
                />
            </span>
            <FormLabel className="col-auto mt-auto px-2">
                To
            </FormLabel>
            <span className="col mt-auto">
                <DateInput
                    value={maxDate}
                    maxDate={new Date()}
                    onBlur={(date) => update(`max${operation}Date`, date)}
                    disableAnimations
                />
            </span>
        </div>
        <div className="col-12 col-lg-4">
            <GenericUserSelect
                label={`${operation} By`}
                defaultValue={byIds}
                isMulti
                isClearable
                onChange={(selections) => update(`${_.toLower(operation)}ByIds`, selections.map(o => o.value))}
                disableAnimations
            />
        </div>
    </>
)

const StandardParagraphFilters = () => {
    const { tempFilter: filter, updateFilter } = useStandardParagraphFilterContext();

    const {
        typeIds,
        minCreatedDate,
        maxCreatedDate,
        createdByIds,
        minPublishedDate,
        maxPublishedDate,
        publishedByIds,
        statuses
    } = filter

    return <>
        <div className="row gy-2">
            <div className="col-12">
                <StandardParagraphTypeSelect
                    label="Type"
                    value={typeIds}
                    setValue={(values) => updateFilter('typeIds', values)}
                    useOnChange
                    disableAnimations
                    isClearable
                    isMulti
                />
            </div>
            <UserOperationFilter
                minDate={minCreatedDate}
                maxDate={maxCreatedDate}
                byIds={createdByIds}
                update={updateFilter}
                operation={"Created"}
            />
            <UserOperationFilter
                minDate={minPublishedDate}
                maxDate={maxPublishedDate}
                byIds={publishedByIds}
                update={updateFilter}
                operation={"Published"}
            />
            <div className="col-12">
                <FormSelect
                    label="Status"
                    defaultValue={statuses}
                    isMulti
                    isClearable
                    onChange={(selections) => updateFilter('statuses', selections.map(o => o.value))}
                    options={[
                        { label: "Never Published", value: 0 },
                        { label: "Published", value: 1 },
                        { label: "Modified", value: 2 }
                    ]}
                    disableAnimations
                />
            </div>
        </div>
    </>
}

export default StandardParagraphFilters;